import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'systemcode-common-btrust-notify',
  templateUrl: './common-btrust-notify.component.html',
  styleUrls: ['./common-btrust-notify.component.css']
})
export class CommonBtrustNotifyComponent implements OnInit {


  @Output()
  public cancel = new EventEmitter();

  @Output()
  public backtoPayment = new EventEmitter();

  public constructor() { }

  public ngOnInit() {
  }

  public backtoPaymentBtnFun() {
    this.backtoPayment.emit();
  }

  public cancelBtnFun() {
    this.cancel.emit();
  };


}
